import { gql, useQuery } from '@apollo/client';
import { getServices } from './__generated__/getServices';

export const GET_SERVICES = gql`
  query getServices {
    bookableServices {
      id
      name
      serviceGroup
      serviceSlug
      expertises {
        id
        name
      }
      appointmentTypes {
        id
        name
        durationMinutes
        mode
      }
      isScreening
    }
  }
`;

export const useGetServices = () => {
  const { data, loading, error, refetch } = useQuery<getServices>(
    GET_SERVICES,
    {
      errorPolicy: 'all',
      returnPartialData: false,
    },
  );

  return { data, loading, error, refetch };
};
